<button
  mat-icon-button
  matTooltipPosition="right"
  [disabled]="!isEnabled()"
  [matTooltip]="tooltipText()"
  (click)="onExecute()"
>
  <mat-icon [style.color]="iconColor()">{{ command().icon }}</mat-icon>
</button>
